module.exports = __webpack_public_path__ + "img/good.1cea7c5a.svg";